import { useCategoryObserver } from "@/hooks/useCategoryObserver";
import { MenuCategory } from "@/hooks/useMenu";
import { cn } from "@/lib/utils";
import { ChevronRightIcon } from "lucide-react";
import { ScrollList } from "./ui/custom/scroll-list";

function CategoryTabs({ categories }: { categories: MenuCategory[] }) {
  const { activeCategory, setActiveCategory } = useCategoryObserver();
  const scrollToCategory = (categoryName: string) => {
    setActiveCategory(categoryName);
    const categoryElement = document.getElementById(categoryName);
    if (categoryElement) {
      categoryElement.scrollIntoView({ behavior: "instant", block: "start" });

      const categoryList = document.querySelector(
        "[data-category-list]"
      ) as HTMLDivElement;
      if (categoryList) {
        categoryList.scroll(categoryList.scrollLeft, categoryList.scrollTop);
      }
    }
  };

  return (
    <ScrollList>
      {categories.map((category) => {
        const isActive =
          activeCategory !== null
            ? activeCategory === category.name
            : category.name === categories[0].name;

        const hasProducts = category.products.length > 0;

        if (!hasProducts) return null;

        return (
          <a
            href={`#${category.name}`}
            data-category-name={category.name}
            key={category.name}
            onClick={(event) => {
              event.preventDefault();
              scrollToCategory(category.name);
            }}
            className={cn(
              "flex-none mx-1 px-3 py-1 @[768px]:py-2 text-sm font-sans tracking-tight cursor-pointer transition-colors duration-200 rounded-full @[768px]:w-full @[768px]:flex @[768px]:justify-between @[768px]:gap-2 @[768px]:items-center",
              isActive
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-muted/50"
            )}
          >
            <span>{category.name}</span>
            <ChevronRightIcon
              className="hidden @[768px]:hidden"
              size={22}
              strokeWidth={1.5}
            />
          </a>
        );
      })}
    </ScrollList>
  );
}

export { CategoryTabs };
